import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "http://ebank.seisea.com/dashboard/transactions",
  target: "_blank"
}, "eBank", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://portal.vietcombank.com.vn/Personal/TG/Pages/ty-gia.aspx",
  target: "_blank"
}, "VCB tỷ giá (Cột Chuyển Khoản)", -1)
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: _ctx.$t('screenTitle.coinChargeManage')
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_collapse, { class: "mb-20" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_collapse_panel, {
            key: "1",
            header: "Lịch sử nạp tiền"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_a_collapse_panel, {
            key: "2",
            header: "Tỷ giá ngoại tệ"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                dataSource: _ctx.dataSourceVcbExchangeRate,
                columns: _ctx.columnsVcbExchangeRate,
                loading: _ctx.isLoadingVcbExchangeRate,
                scroll: {y: '500px'},
                pagination: false,
                size: "small"
              }, {
                title: _withCtx(() => [
                  _createTextVNode("Cập nhật lúc (D/M/Y H:I:S): " + _toDisplayString(_ctx.vcbExchangeRateUpdatedAt) + " ", 1),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = () => _ctx.fetchVcbExchangeRate())
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Cập nhật")
                    ]),
                    _: 1
                  })
                ]),
                footer: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["dataSource", "columns", "loading"])
            ]),
            _: 1
          }),
          (_ctx.googleSheetId.length)
            ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                key: "3",
                header: "Thu chi"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: `https://docs.google.com/spreadsheets/d/${_ctx.googleSheetId}`,
                    target: "_blank"
                  }, "Google sheet", 8, _hoisted_3)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_a_card, { class: "mb-20" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref: "form",
            model: _ctx.formModel,
            onFinish: _ctx.onFinish,
            rules: _ctx.formRule,
            scrollToFirstError: true,
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.payment_username'),
                name: "username"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formModel.username,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formModel.username) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.payment_coin'),
                name: "coin"
              }, {
                help: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('text.preview')) + ": ", 1),
                    _createVNode(_component_a_tag, {
                      color: ((_ctx.formModel.coin || 0) < 0) ? 'red' : 'green'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.number_format(_ctx.formModel.coin)), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: _ctx.formModel.coin,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formModel.coin) = $event)),
                    style: {"width":"200px"},
                    disabled: (_ctx.formModel.coin_promotion || _ctx.formModel.point || 0) !== 0
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.payment_coin_promotion'),
                name: "coin_promotion"
              }, {
                help: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('text.preview')) + ": ", 1),
                    _createVNode(_component_a_tag, {
                      color: ((_ctx.formModel.coin_promotion || 0) < 0) ? 'red' : 'green'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.number_format(_ctx.formModel.coin_promotion)), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: _ctx.formModel.coin_promotion,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formModel.coin_promotion) = $event)),
                    style: {"width":"200px"},
                    disabled: (_ctx.formModel.coin || _ctx.formModel.point || 0) !== 0
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_a_form_item, {
                label: _ctx.$t('labelText.payment_point'),
                name: "point"
              }, {
                help: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('text.preview')) + ": ", 1),
                    _createVNode(_component_a_tag, {
                      color: ((_ctx.formModel.point || 0) < 0) ? 'red' : 'green'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.number_format(_ctx.formModel.point)), 1)
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_input_number, {
                    value: _ctx.formModel.point,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formModel.point) = $event)),
                    max: 0,
                    style: {"width":"200px"},
                    disabled: (_ctx.formModel.coin_promotion || _ctx.formModel.coin || 0) !== 0
                  }, null, 8, ["value", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              (_ctx.formModel.coin)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 0,
                    label: _ctx.$t('labelText.payment_bank_owner'),
                    name: "bank_owner",
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.formModel.bank_owner,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formModel.bank_owner) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bankOwners, (v, i) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: v,
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(v), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (_ctx.formModel.coin)
                ? (_openBlock(), _createBlock(_component_a_form_item, {
                    key: 1,
                    label: _ctx.$t('labelText.payment_bank_type'),
                    name: "bank_type",
                    required: true
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.formModel.bank_type,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formModel.bank_type) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                'ATM',
                                'Paypal',
                                'Thẻ cào',
                                'KRWON - Hàn Quốc',
                                'Yên - Nhật Bản',
                                'Crypt Coin',
                            ], (v, i) => {
                            return _createVNode(_component_a_select_option, {
                              value: v,
                              key: i
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(v), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"])
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    block: "",
                    loading: _ctx.isSaving,
                    disabled: !_ctx.formModel.coin && !_ctx.formModel.coin_promotion && !_ctx.formModel.point
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('text.save')), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "onFinish", "rules"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_table, {
        dataSource: _ctx.dataSource,
        columns: _ctx.columns,
        pagination: _ctx.pagination,
        loading: _ctx.isLoading,
        scroll: {x: '100%'}
      }, null, 8, ["dataSource", "columns", "pagination", "loading"])
    ]),
    _: 1
  }, 8, ["title"]))
}